import { ClassificationBackfillMode } from "@redotech/crdb-enums/internal-ops/classification-backfill-mode";
import { ClassificationBackfillTarget } from "@redotech/crdb-enums/internal-ops/classification-backfill-target";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** 366 days: full calendar year, leap-year inclusive. */
export const MAX_CLASSIFICATION_BACKFILL_RANGE_DAYS = 366;

export const MAX_CLASSIFICATION_BACKFILL_CONCURRENCY = 25;

export const triggerClassificationBackfill = unaryRpc({
  name: "triggerClassificationBackfill" as const,
  input: z
    .object({
      target: z.enum(ClassificationBackfillTarget),
      mode: z.enum(ClassificationBackfillMode),
      startDate: z.date(),
      endDate: z.date(),
      concurrency: z
        .number()
        .int()
        .min(1)
        .max(MAX_CLASSIFICATION_BACKFILL_CONCURRENCY),
    })
    .refine(({ startDate, endDate }) => endDate > startDate, {
      message: "End date must be after start date.",
    })
    .refine(
      ({ startDate, endDate }) =>
        (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) <=
        MAX_CLASSIFICATION_BACKFILL_RANGE_DAYS,
      {
        message: `Date range cannot exceed ${MAX_CLASSIFICATION_BACKFILL_RANGE_DAYS} days.`,
      },
    ),
  output: z.object({ runId: z.string(), workflowId: z.string() }),
});

export type TriggerClassificationBackfillInput = z.infer<
  typeof triggerClassificationBackfill.input
>;

export type TriggerClassificationBackfillOutput = z.infer<
  typeof triggerClassificationBackfill.output
>;
